import { decorate, observable, action } from "mobx"
import autoBind from "auto-bind"

import ApiClient from "utils/ApiClient";
import { CHAT_RESPONSE_INITIAL_VALUES } from '../lib/constants'
import { generateUUID } from "../lib/utils";

class ChatStore {

  loading = false;
  idle = false;
  submitCount = 0;

  isActionRunning = false;
  currentActionName = '';

  chatSessionId = null;
  backendSessionId = null;
  updateMessageIndex = -1;
  chatHistory=[];

  page = 0;

  messages = [];
  response = CHAT_RESPONSE_INITIAL_VALUES;

  constructor() {
    autoBind(this)
  }

  addLog = (params) => {
    ApiClient.Assistant.addLog(params)
  };

  addUserInputToLogs = (message = "", meta_data = "", nodeId = "", parentNodeId = "") => {
    if (this.backendSessionId == null) {
      let params = {
        content: message,
        meta_data: JSON.stringify(meta_data),
      };
      ApiClient.Assistant.addLog(params)
        .then((response) => {
          if (response.success) {
            this.setBackendSessionId(response.data?.session_id);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      let params = {
        id: this.backendSessionId,
        node_id: nodeId,
        parent_row_id: parentNodeId,
        role: "user",
        content: message,
        type: "message",
      };
      this.addLog(params);
    }
  }

  // TODO: need to modify this logic to get parent node ID.
  getParentNodeId() {
    let parentNodeId = 0;
    this.messages.forEach((el) => {
      if (el.node_id) {
        parentNodeId = el.node_id;
      }
    });
    return parentNodeId;
  }

  formatChatMessagesComingFromApi(messages = []) {
    let formatted_messages = [];
    messages.forEach((message, i) => {
      let tempMessage = {
        node_id: i == 0 ? 0 : message.node_id,
        parent_row_id: i == 0 ? 0 : message.parent_row_id,
        content: i == 0 ? message.initial_query : message.content,
        id: message.id,
        type: i == 0 ? "message" : message.type,
        role: i == 0 ? "user" : message.role,
      };
      if (message.type == "function call" || message.role == "function") {
        try {
          let function_call = JSON.parse(message.content);
          tempMessage["name"] = function_call.name;
        } catch (error) {
          console.log(error);
        }
      }
      formatted_messages.push(tempMessage);
    });
    return this.getLatestChatBranch(formatted_messages);
  }

  getLatestChatBranch(messages = []) {
    if (messages.length <= 1) {
      return messages;
    }
    let firstMessage = messages.shift();
    messages.sort((a, b) => {
      return b.id - a.id;
    });

    let latestBranch = [messages.shift()];
    let parent_id = latestBranch[0].parent_row_id;
    messages.forEach((message) => {
      if (message.node_id == parent_id) {
        latestBranch.push(message);
        parent_id = message.parent_row_id;
      }
    });
    latestBranch.sort((a, b) => {
      return a.id - b.id;
    });
    if(latestBranch[0].parent_row_id == "" || latestBranch[0].parent_row_id == 0){
      return latestBranch;
    }
    return [firstMessage, ...latestBranch];
  }

  async loadChatHistory(backendSessionId) {
    try {
      let resp = await ApiClient.Assistant.getChat({
        id: backendSessionId
      })
      if (resp.success) {
        let formatted_messages = this.formatChatMessagesComingFromApi(resp.data);
        this.setChatMessages(formatted_messages);
      }
    } catch (error) {
      // console.log(error)
      this.setChatMessages([]);
    }
  }

  setChatHistory(chatHistory) {
    this.chatHistory = chatHistory
  }


  setChatSessionId(id) {
    this.chatSessionId = id;
  }

  setUpdateMessageIndex(index) {
    this.updateMessageIndex = index;
  }

  async loadChatsHistory(firstLoad = false) {
    if (firstLoad) {
      this.page = 0
      this.chatHistory = []
    }
    try {
      let resp = await ApiClient.Assistant.getChats({ page: this.page, limit: 20 })
      if (resp.success) {
        let historyArray = []
        if (resp.data && resp.data.length === 0) {
          window.appStore.notificationStore.showNotification(
            "No more chats",
            "info"
          );
        } else {
          this.page += 1;
        }
        resp.data?.forEach(el => {
          let tempObj = {
            id: generateUUID(4),
            backendSessionId: el.id,
            messages: [],
            createdAt: el.created_at,
            initial_query: el.initial_query
          }
          historyArray.push(tempObj)
        })
        // this.setChatHistory(historyArray);
        this.chatHistory = [...this.chatHistory, ...historyArray]
        return true
      } else {
        throw new Error("error")
      }
    } catch (error) {
      this.setChatHistory([])
      return false
    }
  }


  resetChatMessages() {
    this.messages = []
  }

  setChatMessages(messages) {
    this.messages = messages
  }

  addChatMessages(messages, inFront = false) {
    if (inFront) {
      this.messages = [...messages, ...this.messages]
    } else {
      this.messages = [...this.messages, ...messages]
    }
    // this.messages = [...this.messages, ...messages]
  }

  addResponsesInBackend(content) {
    ApiClient.Assistant.updateResponses({
      id: this.backendSessionId,
      response: JSON.stringify(content),
    });
  }

  addChatMessage(
    message,
    add_log = true,
    add_response = true
  ) {
    if (
      add_response &&
      message.role == "assistant" &&
      message.type == "message"
    ) {
      this.addResponsesInBackend([message.content]);
    }
    if (add_log) {
      let nodeId = this.backendSessionId ? generateUUID(6) : 0;
      let parentNodeId = this.backendSessionId
        ? this.getParentNodeId()
        : 0;
      const payload = {
        node_id: nodeId,
        parent_row_id: parentNodeId,
        type: "response",
        role: "assistant",
        content: message.content,
      };
      this.addLog({
        ...payload,
        id: this.backendSessionId,
      });
      this.addChatMessages([payload]);
    } else {
      this.addChatMessages([message]);
    }
  };

  removeMessage(index) {
    this.messages.splice(index, 1);
  }

  setSubmitCount(submitCount) {
    this.submitCount = submitCount;
  }

  increaseSubmitCount() {
    this.submitCount += 1;
  }

  setLoading(loading) {
    this.loading = loading;
  }

  setBackendSessionId(id) {
    this.backendSessionId = id
  }

  resetChatResponse() {
    this.response = CHAT_RESPONSE_INITIAL_VALUES
  }

  onError() {
    this.loading = false;
  }

  onIdle() {
    this.idle = true;
  }

  onStart() {
    this.idle = false;
  }

  onResponse(response, cb = () => null) {
    if (response.created)
      this.response.createdAt = response.created
    if (response.function_call) {
      if (response.function_call.name) {
        this.response.functionCall.name = response.function_call.name
      }
      this.response.functionCall.arguments = (this.response.functionCall.arguments || "") + response.function_call.arguments || '';
      cb({ strlen: this.response?.functionCall?.arguments?.length })
    } else {
      this.response.content += response.content || '';
    }
    this.response.role = response.role || 'assistant'
  }

  async onFinish() {
    this.loading = false;
  }

  setActionLoading(isActionRunning) {
    this.isActionRunning = isActionRunning;
  }

  setCurrentActionName(currentActionName) {
    this.currentActionName = currentActionName;
  }

  resetCurrentAction() {
    this.isActionRunning = false;
    this.currentActionName = '';
  }
}

decorate(ChatStore, {

  chatSessionId: observable,
  updateMessageIndex: observable,
  currentActionName : observable,

  loading: observable,
  idle: observable,
  submitCount: observable,
  response: observable,
  messages: observable,
  backendSessionId: observable,

  page: observable,
  chatHistory: observable,
  //
  setLoading: action,
  onIdle: action,
  onStart: action,
  onResponse: action,
  onError: action,
  onFinish: action,
  resetChatResponse: action,
  addChatMessages: action,
  addResponsesInBackend:action,
  addChatMessage:action,
  removeMessage: action,

  resetChatMessages: action,
  //
  setSubmitCount: action,
  increaseSubmitCount: action,

  //
  setChatHistory: action,
  setChatSessionId: action,
  setUpdateMessageIndex: action,
  loadChatHistory: action,
  loadChatsHistory: action,
  //
  isActionRunning: observable,
  setActionLoading: action,
  setCurrentActionName: action,
  resetCurrentAction: action

})

export default ChatStore;